import { Badge, BadgeType } from '@@/Badge';
import { Icon } from '@@/Icon';

import {
  PolicyType,
  getPolicyCategory,
  getPolicyTypeDisplayName,
} from '../types';
import { getPolicyIcon } from '../utils/policy-types-metadata';

interface Props {
  policyType: PolicyType;
  className?: string;
  /** Optional data-cy for testing */
  'data-cy'?: string;
}

export function PolicyTypeBadge({
  policyType,
  className = 'flex items-center gap-1 w-fit',
  'data-cy': dataCy,
}: Props) {
  const category = getPolicyCategory(policyType);
  const displayName = getPolicyTypeDisplayName(policyType);
  const PolicyIcon = getPolicyIcon(category);
  const badgeType: BadgeType = category === 'rbac' ? 'success' : 'info';

  return (
    <Badge type={badgeType} className={className} data-cy={dataCy}>
      <Icon icon={PolicyIcon} className="!h-3.5 !w-3.5" />
      {displayName}
    </Badge>
  );
}
